import { render, staticRenderFns } from "./PageStructureSectionColorsNew.vue?vue&type=template&id=11d0cc60&"
import script from "./PageStructureSectionColorsNew.vue?vue&type=script&lang=ts&"
export * from "./PageStructureSectionColorsNew.vue?vue&type=script&lang=ts&"
import style0 from "./PageStructureSectionColorsNew.vue?vue&type=style&index=0&id=11d0cc60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports